<template>
  <div v-if="content">
    <v-form ref="form" @submit.stop.prevent>
      <v-text-field
        v-model.trim="content.title"
        :disabled="!customContentEnabled"
        :label="$t('socialMediaPost.edit.title')"
        tabindex="1"
        clearable
      ></v-text-field>

<!--      <p-wysiwyg-editor-->
<!--        v-model="content.message"-->
<!--        :disabled="!customContentEnabled"-->
<!--        :label="$t('socialMediaPost.edit.message')"-->
<!--        tabindex="1"-->
<!--      ></p-wysiwyg-editor>-->
      <PSyncfusionRichTextEditor
        v-model="content.message"
        :enabled="customContentEnabled"
        :label="$t('socialMediaPost.edit.message')"
        tabindex="1"/>

      <p-file-input
        ref="fileInput"
        v-model="content.images"
        :disabled="!customContentEnabled"
        :label="$t('socialMediaPost.edit.images')"
        accept="image/*"
        primary-enabled
        :primary-text="$t('socialMediaPost.edit.featured')"
        show-reorder-hint
        library-enabled
        :library-file-type="fileType.socialMedia"
        :is-marketing="true"
        multiple
        clearable
      ></p-file-input>

      <p-file-preview-area
        ref="filePreviewArea"
        :files.sync="content.images"
        :files-data-by-guid-default="defaultContent.filesDataByGuid"
        :disabled="!customContentEnabled"
      >
      </p-file-preview-area>

      <v-textarea
        v-model.trim="content.embedMedia"
        :disabled="!customContentEnabled"
        :label="$t('socialMediaPost.edit.embedMedia')"
        tabindex="1"
        rows="1"
        auto-grow
      ></v-textarea>

      <v-checkbox
        v-model="content.includeEvents"
        :disabled="!customContentEnabled"
        :label="$t('socialMediaPost.edit.includeEvents')"
        :hint="content.includeEvents ? $t('socialMediaPost.edit.includeEvents_hint') : ''"
        persistent-hint
      ></v-checkbox>
      <included-events-list v-if="content.includeEvents" />

      <v-checkbox
        v-model="content.featured"
        :disabled="!customContentEnabled"
        :label="$t('socialMediaPost.edit.featuredPost')"
      ></v-checkbox>

      <v-row>
        <v-col cols="12" md="6">
          <p-date-time-picker
            v-model="content.scheduledPublishTimeUtc"
            :disabled="!customContentEnabled"
            :label="$t('socialMediaPost.edit.scheduledPublishTime')"
            tabindex="1"
            clearable
          ></p-date-time-picker>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" md="6">
          <p-date-time-picker
            v-model="content.unPublishTimeUtc"
            :rules="rules.unPublishTimeUtc"
            :disabled="!customContentEnabled"
            :label="$t('socialMediaPost.edit.unPublishTime')"
            :min="content.scheduledPublishTimeUtc"
            tabindex="1"
            clearable
          ></p-date-time-picker>
        </v-col>
      </v-row>
    </v-form>
  </div>
</template>


<script>
import { fileType } from '@/constants'

import PDateTimePicker from '@/components/PDateTimePicker'
// import PWysiwygEditor from '@/components/PWysiwygEditor'
import PSyncfusionRichTextEditor from '@/components/PSyncfusionRichTextEditor'
import PFileInput from '@/components/PFileInput'
import PFilePreviewArea from '@/components/PFilePreviewArea'

import IncludedEventsList from '../IncludedEventsList'

import objectMixin from '@/mixins/object.mixin'
import fileMixin from '@/mixins/file.mixin'
import validationMixin from '@/mixins/validation.mixin'


export default {
  components: {
    PDateTimePicker,
    // PWysiwygEditor,
    PSyncfusionRichTextEditor,
    PFileInput,
    PFilePreviewArea,
    IncludedEventsList
  },


  mixins: [
    objectMixin,
    fileMixin,
    validationMixin
  ],


  props: {
    channelId: {
      type: String
    },
    customContent: {
      type: Object
    },
    customContentEnabled: {
      type: Boolean
    },
    defaultContent: {
      type: Object
    }
  },


  data () {
    return {
      content: null,
      fileType,
      additionalFields: []
    }
  },


  computed: {
    rulesToApply () {
      const rule = this.rule
      return {
        unPublishTimeUtc: [rule.dateLaterThen(this.content.scheduledPublishTimeUtc)]
      }
    }
  },


  watch: {
    customContentEnabled () {
      this.setContent()
    }
  },


  methods: {
    async fileInputUploadFiles () {
      this.showSnackbar(this.$t('socialMediaPost.edit.uploadingImages'))
      await this.$refs.fileInput.uploadFiles(this.currentProjectId, fileType.socialMedia)
    },

    setContent (content) {
      const defaultContent = content || this.defaultContent
      this.content = this.customContentEnabled ? this.customContent : defaultContent
    }
  },


  created () {
    this.setContent()
  }
}
</script>
